import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon, SweetAlertPosition, SweetAlertResult, SweetAlertOptions } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  constructor() {}

  public fireSweetAlert(
    title: string,
    content: string,
    icon: SweetAlertIcon,
    isToast: boolean = false,
    returnPromise?: boolean,
    error?: any,
    isHtml: boolean | Partial<SweetAlertOptions> = false,
    overrides: Partial<SweetAlertOptions> = {}
  ): Promise<SweetAlertResult | void> {

    if (typeof isHtml !== 'boolean') {
      overrides = isHtml;
      isHtml = false;
    }

    let position: SweetAlertPosition = isToast ? 'top-right' : 'center';
    let showConfirmButton: boolean = isToast ? false : true;
    let timer: number = isToast ? 3000 : 0;

    const swalConfig: SweetAlertOptions = {
      toast: isToast,
      position,
      icon,
      titleText: title,
      showConfirmButton,
      timer,
      reverseButtons: true,
      timerProgressBar: true,
      ...(overrides as SweetAlertOptions)
    };

    if (isHtml) {
      swalConfig.html = content;
    } else {
      swalConfig.text = content;
    }

    const swalPromise = Swal.fire(swalConfig);

    // Report error
    if (error) {
      console.error(error);
    }
    if (returnPromise) {
      return swalPromise;
    } else {
      // Resolve the promise immediately if not handling it
      swalPromise.then(() => { });
      return Promise.resolve();
    }
  }
}
